module.exports = __webpack_public_path__ + "img/HC3P_Logo.54bf2d69.png";